<template>
  <div>
    <v-card>
      <div class="d-flex justify-space-between align-center pt-1 pl-2">
        Incidencias Reportadas
        <v-sheet max-width="100px">
          <v-select
            class="pa-0 ma-0"
            v-model="checkIncidence"
            :items="filters"
            @change="changeFilterDateIncidence"
            hide-details
          ></v-select>
        </v-sheet>
      </div>
      <v-divider></v-divider>
      <v-container>
        <v-card
          elevation="0"
          @click="
            $router.push({
              name: 'damagesChecklist',
              query: {
                startAt: globalQuery.startAt,
                endAt: globalQuery.endAt,
                status: 'Damages',
                user: null
              }
            })
          "
        >
          <div
            v-if="showDatesSelectedInicidence"
            class="d-flex align-center justify-end"
          >
            {{ datesSelectedIncidence.join(" ~ ") }}
            <v-btn
              x-small
              class="ma-0 ml-2"
              @click="showCalendarIncidence = true"
              >cambiar</v-btn
            >
          </div>
          <div class="d-flex justify-center" v-if="loadingIncidence">
            <v-progress-circular
              indeterminate
              size="50"
              color="primary"
            ></v-progress-circular>
          </div>
          <p v-else class="text-analytics ma-0 text-center orange--text">
            {{ totalIncidence }}
          </p>
        </v-card>
      </v-container>
    </v-card>
    <v-dialog v-model="showCalendarIncidence" max-width="300" persistent>
      <v-card>
        <div class="d-flex justify-end">
          <v-icon @click="closeCalendar" class="ml-2 mt-1">close</v-icon>
        </div>
        <v-container>
          <v-date-picker
            v-model="datesSelectedIncidence"
            multiple
            :disabled="datesSelectedIncidence.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelectedIncidence.length < 2"
              @click="searchByDatesIncidence"
              >Aceptar</v-btn
            >
            <v-btn color="error" @click="resetDatesIncidence">Borrar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      filters: ["Hoy", "Este mes", "Rango de fechas"],

      checkIncidence: "Este mes",

      showCalendarIncidence: false,

      showDatesSelectedInicidence: false,

      loadingIncidence: false,

      datesSelectedIncidence: [],

      incidenceData: [],
      totalIncidence: 0,
      globalQuery: null
    };
  },
  computed: {
    ...mapState("user", ["data"])
  },
  async mounted() {
    this.loadingIncidence = true;
    const queryMonth = {
      startAt: `${moment()
        .startOf("month")
        .format("YYYY-MM-DD")}`,
      endAt: `${moment()
        .endOf("month")
        .format("YYYY-MM-DD")}`
    };
    this.getIncidenceData(queryMonth);
  },
  methods: {
    ...mapActions("checklist", ["getAnalytics"]),
    async changeFilterDateIncidence(value) {
      switch (value) {
        case "Rango de fechas": {
          this.showCalendarIncidence = true;
          this.showDatesSelectedInicidence = true;
          break;
        }
        case "Hoy": {
          this.loadingIncidence = true;
          const query = {
            startAt: `${moment().format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .add(1, "days")
              .format("YYYY-MM-DD")}`
          };
          this.getIncidenceData(query);
          this.showDatesSelectedInicidence = false;
          break;
        }
        case "Este mes": {
          this.loadingIncidence = true;
          const queryMonth = {
            startAt: `${moment()
              .startOf("month")
              .format("YYYY-MM-DD")}`,
            endAt: `${moment()
              .endOf("month")
              .format("YYYY-MM-DD")}`
          };
          this.getIncidenceData(queryMonth);
          this.showDatesSelectedInicidence = false;
          break;
        }
      }
    },
    closeCalendar() {
      this.showCalendarIncidence = false;
      this.showDatesSelectedInicidence = false;
      this.filterDateStatus = "Este mes";
      this.changeFilterDateIncidence("Este mes");
    },
    searchByDatesIncidence() {
      this.loadingIncidence = true;
      const queryMonth = {
        startAt:
          this.datesSelectedIncidence[0] < this.datesSelectedIncidence[1]
            ? this.datesSelectedIncidence[0]
            : this.datesSelectedIncidence[1],
        endAt:
          this.datesSelectedIncidence[1] > this.datesSelectedIncidence[0]
            ? this.datesSelectedIncidence[1]
            : this.datesSelectedIncidence[0]
      };
      this.getIncidenceData(queryMonth);
      this.showCalendarIncidence = false;
    },

    async getIncidenceData(query) {
      try {
        this.globalQuery = query;
        this.incidenceData = await this.getAnalytics(query);
        this.totalIncidence = this.getIncidencesFilter(this.incidenceData);
        this.loadingIncidence = false;
      } catch (error) {
        this.loadingIncidence = false;
      }
    },
    getIncidencesFilter(data) {
      const filter = data.filter(currentData => {
        return currentData.incidence === true;
      });
      return filter.length;
    },

    resetDatesIncidence() {
      this.datesSelectedIncidence = [];
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
</style>
